import Backbone from 'backbone'
import template from './attach-orgless-v2-report.hbs'
import MoveToOrgWizard from './move-to-org-wizard'
import { domainType } from 'scoreboard/reports/report'

/**
 * View to attach an orgless report that came from version 2 of the software (#20095)
 */
const AttachOrglessV2Report = Backbone.View.extend({

	events: {
		'click .button-primary': 'saveToOrganization'
	},

	render() {
		this.$el.html(template())
		return this
	},

	saveToOrganization (e) {
		this.stopListening(Backbone, 'attach:domain-object')
		this.listenToOnce(Backbone, 'attach:domain-object', data => {
			this.trigger('done', data.orgId)
		})

		let wizard = new MoveToOrgWizard({
			mode: 'move',		//use move validation rules
			object: this.model.attributes,
			section: 'reports',
			domainType
		})
		wizard.start()
	}

})

export default AttachOrglessV2Report
AttachOrglessV2Report.__filename__ = 'bookmarks/attach-orgless-v2-report.js'
